import { SettingsSuggestOutlined as SettingsSuggestOutlinedIcon } from '@automata/mui-theme/icons';
import { Tooltip, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import React from 'react';

import { selectSelectionPanel } from '../../../features/ui/selectors';
import {
  closeSelectionPanel,
  openSelectionPanel,
} from '../../../features/ui/uiSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';

const ViewSettingsToolbar = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const currentSelectionPanel = useAppSelector(selectSelectionPanel);
  const theme = useTheme();

  return (
    <Box boxShadow={3} borderRadius={1} bgcolor={theme.palette.common.white}>
      <Tooltip title="View settings" placement="right">
        <ToggleButton
          value={{}}
          selected={currentSelectionPanel === 'viewSettings'}
          onClick={() => {
            dispatch(closeSelectionPanel());
            if (currentSelectionPanel !== 'viewSettings') {
              dispatch(openSelectionPanel('viewSettings'));
            }
          }}
        >
          <SettingsSuggestOutlinedIcon color="neutral" />
        </ToggleButton>
      </Tooltip>
    </Box>
  );
};

export default ViewSettingsToolbar;
